<template>
  <div class="intro">
    <div class="grid-lines">
      <div class="intro-container">
        <div class="heading-wrapper">
          <h1>
            Invest in one of the world’s leading <br />
            price comparison engines for used cars.
          </h1>
          <div class="subtext-1">OOYYO is a synonym for buying used cars.</div>

          <div class="buttons-wrapper">
            <button class="invest-button" @click="onModalOpen('investor')">
              Apply for investment
            </button>
            <button
              class="invest-button-outline"
              @click="onModalOpen('general')"
            >
              More information
            </button>
          </div>

          <div class="subtext-2">
            <strong>5,000 RETURN</strong> <span class="text-primary">on Investment Opportunity</span>
          </div>
        </div>

        <div class="bottom-wrapper">
          <div class="info">
            <img class="image-title" src="@/images/investment/cube.png" />
            <div class="subtext-1">Big data driven</div>
            <div class="subtext-2">What we do?</div>
            <p class="subtext-3">
              OOYYO aggregates and analyzes more than <strong>10.000.000</strong> car listings <strong>worldwide!</strong>
              <br>
              We allow tens of millions of car buyers to get relevant prices and
              find affordable cars in an efficient and easy way.
            </p>
          </div>
          <div class="steps">
            <div class="step">
              <img src="@/images/investment/step-1.png" />
              Search
            </div>
            <div class="step">
              <img src="@/images/investment/step-2.png" />
              Review
            </div>
            <div class="step">
              <img src="@/images/investment/step-3.png" />
              Direct to seller VDP
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onModalOpen: {
      type: Function,
      default: () => {}
    }
  }
}
</script>
